import React, { Component } from 'react'
import SerializeForm from 'form-serialize'
import PropTypes from 'prop-types'
import ReactRouterPropTypes from 'react-router-prop-types'

import { connect } from 'react-redux'
import * as api from '../api/api'
import * as actions from '../actions'

// React Material Web Components
import { Grid, GridCell } from 'rmwc/Grid';
import { FormField } from 'rmwc/FormField';
import { TextField, TextFieldIcon } from 'rmwc/TextField';
import { Card } from 'rmwc/Card';

import { Typography } from 'rmwc/Typography';
import centaLogo from '../assets/images/centa-logo-new.png';
import { Button } from 'rmwc/Button';
import StatusMessage from '../util/StatusMessage'


class ConfirmRegistration extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorMsg: '',
      modal: false,
      validationErrors: {
        phoneNumberError: '',
        passwordError: '',
      },
      userInfo: {
        accessToken: '',
        client: '',
        uid: '',
        email: '',
        id: '',
        role: '',
        userName: '',
        image: '',
        phone: ''
      },
    }

    this.handleSubmit = this.handleSubmit.bind(this)
    this.checkForErrors = this.checkForErrors.bind(this)
    
  }

  checkForErrors(values){
    return false;
  }

  handleSubmit(e) {
    e.preventDefault()
    return
    const values = SerializeForm(e.target, { hash: true })
    const obj = {}
    // console.log(values)
    const err = this.checkForErrors(values)
    if (!err) {
      api
        .confirmRegistration(values)
        .then((result) => {
          const { status, data, errors } = result
          if (status === 'error') {
            this.setState({ errorMsg: JSON.Stringify(errors) })
          }
          if (status === 'success') {
            this.setState({ errorMsg: '' })
            obj.accessToken = result.headers.accessToken            
            console.log('after setting header')
            obj.userName = data.userName
            obj.id = data.id
            obj.role = data.role
            this.props.userLogin(obj)
            this.props.history.push('/portal/app/welcome_page')
          }
        })
        .catch((err) => {
          this.setState({ errorMsg: 'Error in confirmation' })
        })
    }
  }


  render() {
    return (
      <div>
        <Grid className="login-card">
          <GridCell span="4" align="middle"></GridCell>
          <GridCell className="align-center" span="4">
            <form onSubmit={this.handleSubmit}>
              <Card style={{width: '21rem',padding: '25px'}}>
                <GridCell>
                  <div style={{padding: '0 1rem 1rem 1rem'}}>
                    <img src={centaLogo} alt="logo" />
                    <Typography tag="h5">Please enter the OTP (One Time Password) received on your registered mobile number.</Typography>
                    <Typography
                      use="subheading1"
                      tag="h3"
                      theme="text-secondary-on-background"
                      style={{marginTop: '-1rem'}}
                    >
                    </Typography>
                  </div>
                </GridCell>
                <GridCell>
                  <FormField style={{width: '100%'}}>
                    <div className="login_icon">
                      <TextFieldIcon use="lock_open"/>
                    </div>
                    <TextField fullwidth label="OTP" autoComplete="off" name="confirmationOtp" className='user_name' />
                  </FormField>
                </GridCell>
                <GridCell className='submit-button'>
                  <FormField>
                    
                  </FormField>
                  <Typography use="body1" tag="a" href="/portal/regenerate_otp" className="forgot-password-link">Regenerate OTP?</Typography>
                </GridCell>
              </Card>
            </form>
            <StatusMessage 
            error_msg = {this.state.errorMsg}
            />
          </GridCell>
          <GridCell span="4" align="middle"></GridCell>
        </Grid>
      </div>
    )
  }
}

function mapStateToProps() {
  return {}
}

function mapDispatchToProps(dispatch) {
  return {
    userLogin: data => dispatch(actions.userLogin(data)),
    adminLogin: data => dispatch(actions.adminLogin(data)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmRegistration)




// WEBPACK FOOTER //
// ./src/views/ConfirmRegistration.jsx